import { useContext } from 'react';
import { I18nContext } from './i18n-context';

export function useI18nContext() {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18nContext must be used within a LanguageProvider');
  }
  return context;
}
